/* ==========================================================================
   Dom helpers
   ========================================================================== */

const elementExist = element => !!document.querySelector(element);

const toNode = html => new DOMParser().parseFromString(html, 'text/html').body.childNodes;

module.exports = {
    elementExist,
    toNode
};
